import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { PATH_PAYMENT_RATE_TYPES } from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'

const payRateTypes = {
  namespaced: true,
  state: buildInitialState({
    payRateTypesList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setPayRateTypes: (state, payRateTypes) => {
      state.payRateTypesList = payRateTypes
    }
  },
  actions: {
    getPayRateTypes: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_PAYMENT_RATE_TYPES })
        .then(json => json.data)
        .then(payRateTypes => {
          commit('updateStatus', { status: COMPLETE })
          commit('setPayRateTypes', payRateTypes)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  }
}

export default payRateTypes
